import React, { useCallback, useEffect } from 'react'
import { ErrorReportForm } from '@components/ErrorReport/ErrorReport'
import { Panel } from '@components/Panel/Panel'
import { useStore } from 'store/store'

import { usePanelActions } from './layouts/hooks/usePanelActions'

export const BugReportPanel = () => {
    const sidePanel = useStore(({ sidePanel }) => sidePanel)
    const setSidePanel = useStore(({ setSidePanel }) => setSidePanel)
    const { closePanel } = usePanelActions()

    useEffect(() => {
        // set this on mount
        setSidePanel('bugReport')
    }, [setSidePanel])

    const onClose = useCallback(() => {
        setSidePanel(null)
        closePanel()
    }, [closePanel, setSidePanel])

    const isBugPanelOpened = sidePanel === 'bugReport'

    return isBugPanelOpened ? (
        <Panel label="Bug Report" onClosed={onClose}>
            <ErrorReportForm onHide={onClose} />
        </Panel>
    ) : null
}
